import React, { lazy, PropsWithChildren, Suspense } from 'react';
import useGetEngine from '../../Hook/UseGetEngine';

const Default = lazy(() => import('./Default'));
const Viisi = lazy(() => import('./Viisi'));
const Findesk = lazy(() => import('./Findesk'));
const EBlinqx = lazy(() => import('./EBlinqx'));

const ThemeSelector: React.FC<PropsWithChildren> = ({ children }) => {
    const { isAdviesbox, isViisi, isDefault, isFindesk, isFastlane } = useGetEngine();

    return (
        <Suspense fallback={<></>}>
            {isAdviesbox() && <EBlinqx />}
            {isViisi() && <Viisi />}
            {isFindesk() && <Findesk />}
            {isFastlane() && <EBlinqx />}
            {isDefault() && <Default />}
            {children}
        </Suspense>
    );
}

export default ThemeSelector;
